// src/components/FloorPlanGenerator/Instructions.js
import React from 'react';

const Instructions = () => (
  <div className="instructions">
    <h3>Instructions:</h3>
    <ol>
      <li>Select a zone type from the buttons above</li>
      <li>Click and drag on the grid to create a zone</li>
      <li>Use the rotate button (⟳) to rotate buildings</li>
      <li>Click the × button to delete a zone</li>
      <li>Use AI Generate for automatic layout suggestions</li>
      <li>Save your work using the Save button</li>
    </ol>
  </div>
);

export default Instructions;